import { useCommonImages } from "src/apps/hooks/useCommonImages";
import { CommonImageKeys } from "src/contexts/_shared/domain/ImageKeys";
import styled from "styled-components";
import { LocaleSelector } from "../localeSelector/LocaleSelector";
import { MEDIA_MOBILE_BREAKPOINT } from "../../config/constants";
import { Avatar } from "../avatar/Avatar";
import { Banner } from "../banner/Banner";
import { useTheme } from "src/apps/providers/ThemeStore";
import { LogoutFlow } from "../logoutFlow/LogoutFlow";
import { useAuth } from "src/apps/hooks/useAuth";
import { useIsMedia } from "src/apps/hooks/useIsMedia";
import { useLocale } from "src/apps/hooks/useLocale";
import { colors, ColorValue } from "@permisso/permisso-components";

/* TODO: As soon as this Component Header changes more,
  both props showAvatar and showBanner will have to be replaced
  by something like ReactNodes to be customized from the outside */

interface HeaderProps {
  backgroundColor?: ColorValue;
  showBanner?: boolean;
}

export const Header = ({ backgroundColor = colors.grey0, showBanner = false }: HeaderProps) => {
  const { removePoweredBy, removeHeader, removeCustomerLogo } = useTheme();
  const { locale, availableLocales } = useLocale();
  const { token, isLoginlessAccessToken } = useAuth();
  const { isDesktop } = useIsMedia();

  if (removeHeader) return null;
  return (
    <>
      <HeaderContainer $backgroundColor={backgroundColor}>
        <LeftContainer>
          {!removeCustomerLogo ? <Avatar width={isDesktop ? "2.563rem" : "2rem"} /> : null}
        </LeftContainer>
        <RightContainer>
          {!removePoweredBy ? (
            <>
              <PermissoLogo src={useCommonImages(CommonImageKeys.POWERED_BY_PERMISSO_LOGO)} />
              {!availableLocales || availableLocales.length < 2 || !locale ? null : <Separator />}
            </>
          ) : null}
          {!availableLocales || availableLocales.length < 2 || !locale ? null : <LocaleSelector />}
          {token && !isLoginlessAccessToken ? (
            <>
              <Separator />
              <LogoutFlow />
            </>
          ) : null}
        </RightContainer>
      </HeaderContainer>
      {showBanner ? <Banner /> : null}
    </>
  );
};

const SideContainer = styled.header`
  display: flex;
  flex-grow: 1;
  align-items: center;
  height: 3.75rem;
  gap: 0.75rem;

  @media (max-width: ${MEDIA_MOBILE_BREAKPOINT}rem) {
    gap: 0.5rem;
  }
`;

const Separator = styled.div`
  height: 1.313rem;
  border-left: 0.063rem solid ${colors.grey700};
`;

const LeftContainer = styled(SideContainer)`
  padding-left: 5rem;
  justify-content: flex-start;
  @media (max-width: ${MEDIA_MOBILE_BREAKPOINT}rem) {
    padding-left: 1rem;
  }
`;

const RightContainer = styled(SideContainer)`
  padding-right: 5rem;
  justify-content: flex-end;
  @media (max-width: ${MEDIA_MOBILE_BREAKPOINT}rem) {
    padding-right: 1.5rem;
  }
`;

const HeaderContainer = styled.div<{ $backgroundColor: ColorValue }>`
  display: flex;
  flex-direction: row;
  background-color: ${({ $backgroundColor }) => $backgroundColor};
`;

const PermissoLogo = styled.img`
  width: 8.75rem;
  @media (max-width: ${MEDIA_MOBILE_BREAKPOINT}rem) {
    width: 8.375rem;
  }
`;
